// Champion Phase B strings (Golem, Lich, generic abilities, statuses, Soul) —
// English. Merged in ./messages.ts next to gameLegendsEn.ts. Numbers in the
// copy are always template variables read from `legendRows`, never literals.

export const gameLegendsKindsEn = {
  'champion.kind.golem': 'Golem',
  'champion.kind.lich': 'Lich',
  'champion.ability.bulwark': 'Bulwark',
  'champion.ability.withering': 'Withering',
  'champion.ability.ascend': 'Ascend',
  'champion.ability.witheringHint':
    'Curse every enemy within {radius} of a hex up to {range} tiles away: their attacks weaken for {seconds}s. No damage.',
  'champion.ability.bulwarkHint':
    'Hold the line: garrison into an adjacent city of yours, or fortify where it stands. Either way it takes reduced damage; leaving recharges {seconds}s.',
  'champion.ability.ascendHint':
    'Once per life, with a full Soul: +{attack} attack and +{hp} max health.',
  'champion.ability.reason.soul': 'Needs a full Soul ({have} / {need}).',
  'champion.ability.reason.ascended': 'Already ascended.',
  'champion.ability.reason.inert': 'Inert while garrisoned.',
  'champion.ability.targetingRange': 'Pick a target hex within {range} tiles (Esc to cancel)',
  'champion.bulwark.fortify': 'Fortify here',
  'champion.bulwark.garrison': 'Garrison in {city}',
  'champion.bulwark.liftGarrison': 'Leave the city',
  'champion.bulwark.liftFortify': 'Break fortification',
  'champion.state.garrison': 'Garrisoned: inert inside the city, which takes reduced damage.',
  'champion.state.fortify': 'Fortified: cannot move, takes reduced damage.',
  'champion.soul.label': 'Soul',
  'champion.soul.value': '{soul} / {max}',
  'champion.soul.ready': 'Ascend ready',
  'champion.soul.hint': 'Grows by 1 for each enemy that dies within {range} tiles.',
  'champion.phylactery.fallbackCity': 'its summoning city',
  'champion.phylactery.panel': 'Bound to {city}: it dies if that city falls.',
  'champion.status.title': 'Status effects',
  'champion.status.wither': 'Wither',
  'champion.status.fortify': 'Fortified',
  'champion.status.garrison': 'Garrisoned',
  'champion.status.ascended': 'Ascended',
  'champion.status.witherHint': 'Attack rolls -{mag}',
  'champion.status.fortifyHint': 'Cannot move, takes reduced damage',
  'champion.status.garrisonHint': 'Inside a city, inert',
  'champion.status.ascendedHint': 'Attack rolls +{mag}',
  'champion.status.left': '{seconds}s left',
  'champion.err.condition_unmet': 'The conditions for that ability are not met.',
  'champion.err.condition_unmet.bulwark':
    'Bulwark needs an adjacent city of yours (garrison) or the Golem’s own hex (fortify).',
  'champion.err.condition_unmet.ascend': 'Ascend needs a full Soul, and works once.',
  'champion.err.fortified': 'A fortified Golem cannot move. Break the fortification first.',
  'champion.summon.blurb.dragon':
    'A Dragon answers the call of a great city. One Champion at a time.',
  'champion.summon.blurb.golem':
    'A Golem rises from the forge: a slow stone guardian that anchors your cities. One Champion at a time.',
  'champion.summon.blurb.lich':
    'A Lich rises from the necropolis: a frail caster that feeds on the fallen. One Champion at a time.',
  'champion.summon.offeredBy': 'Your dominant doctrine offers the {kind}.',
  'champion.summon.phylactery': 'Bound to this city: if it falls, the Lich dies.',
  'champion.summon.phylacheryHere': 'The Lich’s phylactery is here: if this city falls, it dies.',
  'champion.site.golem_forge': 'Golem Forge',
  'champion.site.necropolis': 'Necropolis',
  'event.legend.ability.firestorm': 'Firestorm',
  'event.legend.ability.bulwark': 'Bulwark',
  'event.legend.ability.withering': 'Withering',
  'event.legend.ability.ascend': 'Ascend',
  'event.legend.ability.generic': 'Champion ability',
  'event.detail.legend.firestorm': '{hits} hit, {kills} slain',
  'event.detail.legend.withering': '{hits} withered',
  'event.detail.legend.bulwark': 'The Golem changes stance',
  'event.detail.legend.ascend': 'The Lich ascends',
  'event.detail.legend.generic': '{hits} affected',
  'cinematic.legendSummoned.subtitle.dragon': 'A dragon answers your call.',
  'cinematic.legendSummoned.subtitle.golem': 'A guardian of stone answers your call.',
  'cinematic.legendSummoned.subtitle.lich': 'A master of the dead answers your call.',
  'cinematic.legendSummoned.kid.dragon': 'A giant dragon joined you!',
  'cinematic.legendSummoned.kid.golem': 'A giant stone golem joined you!',
  'cinematic.legendSummoned.kid.lich': 'A spooky skeleton wizard joined you!',
  'cinematic.legendFallen.kid.dragon': 'Your dragon fell down!',
  'cinematic.legendFallen.kid.golem': 'Your stone golem fell down!',
  'cinematic.legendFallen.kid.lich': 'Your skeleton wizard fell down!',
} as const;
